import { Text, VStack } from '@elkaso-app/web-design';

interface IErpSupplierCell {
  name: string;
  id: number;
  type: string;
}

export const ErpSupplierCell: React.FC<IErpSupplierCell> = ({ name, id, type }) => (
  <VStack align='start' spacing={1}>
    <Text fontWeight='medium'>{name}</Text>
    <Text fontSize='sm' color='gray.500'>
      ID: {id} | Type: {type}
    </Text>
  </VStack>
);
